/*--------------------------------------------------------------
# JS Choices
--------------------------------------------------------------*/

import Choices from 'choices';

const selectElements = document.querySelectorAll(".choices-field");

if (selectElements.length > 0) {
    selectElements.forEach((selectElement) => {
        const placeholderText = selectElement.dataset.placeholder || "Sélectionner une option";
        const blockTitle = selectElement.dataset.title || null;
        const blockSubtitle = selectElement.dataset.subtitle || null;
        const hiddenColumns = selectElement.dataset.hiddenColumns || false;
        const hiddenImage = selectElement.dataset.hiddenImage || false;
        const classes = selectElement.dataset.classes 
        ? selectElement.dataset.classes.split(',').map(cls => cls.trim())
        : [];

        const options = Array.from(selectElement.options).map(option => ({
            value: option.value,
            label: option.text,
            customProperties: {
                sublabel: option.dataset.sublabel || "",
                image: option.dataset.image || "",
                discount: option.dataset.discount || "",
                originalPrice: option.dataset.originalPrice || "",
                price: option.dataset.price || "",
                round: option.dataset.round || "",
            },
        }));

        new Choices(selectElement, {
            removeItemButton: false,
            searchEnabled: false,
            shouldSort: false,
            choices: options,
            placeholder: true,
            placeholderValue: placeholderText,
            classNames: {
                list: ['row', 'g-3', 'choices__list', ...classes],
            },
            callbackOnCreateTemplates: function (template) {
                let isFirstItemHandled = false;

                return {
                  choice: (classNames, data) => {
                    const { customProperties } = data;
                    
                    const sublabel = customProperties.sublabel || "";
                    const image = customProperties.image || "";
                    const discount = customProperties.discount || "";
                    const originalPrice = customProperties.originalPrice || "";
                    const price = customProperties.price || "";

                    const round = customProperties.round || "";

                    const isSelected = data.selected;

                    let headerHtml = "";
                    if (!isFirstItemHandled && blockTitle) {
                        headerHtml = `
                            <div class="col-md-12 mt-0">
                                <p class="h4 text-black my-1">${blockTitle}</p>
                                <p class="text-gray-60 m-0">${blockSubtitle || ''}</p>
                            </div>
                        `;

                        isFirstItemHandled = true;
                    }

                    const formCheckClass = hiddenImage 
                    ? "justify-content-center"
                    : "justify-content-end";

                    const columnClass = hiddenColumns 
                    ? "col-md-12"
                    : "col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4";

                    const textColumnClass = hiddenImage 
                    ? "col-11 col-md-12 col-lg-12 col-xl-11"
                    : "col-6 col-md-7 col-lg-7 col-xl-6";

                    return template(`
                        ${headerHtml}

                        <div class="${columnClass}" data-choice ${data.disabled ? 'data-choice-disabled aria-disabled="true"' : 'data-choice-selectable'} data-id="${data.id}" data-value="${data.value}">
                            <div class="card card-product h-100 is-small ${isSelected ? 'is-selected' : ''}">
                                <div class="row g-0 d-flex align-items-center">
                                    <div class="col-1 d-flex d-md-none d-lg-none d-xl-flex ${formCheckClass}">
                                        <div class="form-check d-flex align-items-center m-0 h-100">
                                            <input class="form-check-input m-0" type="radio" ${isSelected ? 'checked="checked"' : ''}>
                                        </div>
                                    </div>

                                    ${
                                        hiddenImage 
                                        ? ''
                                        : `<div class="col-5">
                                            ${
                                                discount 
                                                ? `<div class="badge bg-danger text-white text-center fw-bolder">${discount}</div>`
                                                : ''
                                            }
                                            ${
                                                image 
                                                ? `<img src="${image}" class="card-img" alt="${data.label}">`
                                                : ''
                                            }
                                        </div>`
                                    }

                                    <div class="${textColumnClass}">
                                        <div class="card-content">
                                            <div class="card-title">
                                                <p class="h6 fw-bolder text-black text-uppercase">${data.label}</p>
                                            </div>

                                            <div class="card-price">
                                                ${
                                                    sublabel 
                                                    ? `<p class="small fw-normal m-0">${sublabel}</p>`
                                                    : ''
                                                }

                                                <div class="price d-flex flex-row align-items-center pt-2">
                                                    ${
                                                        hiddenImage 
                                                        ? `
                                                            ${discount 
                                                                ? `<div class="position-relative me-2 badge bg-danger text-white text-center fw-bolder">${discount}</div>` 
                                                                : ''
                                                            }
                                                        `
                                                        : ''
                                                    }
                                                    ${
                                                        originalPrice
                                                        ? `<span class="old-price fw-normal text-decoration-line-through small fs-xxl-6 me-2">${originalPrice}€</span>`
                                                        : ''
                                                    }
                                                    ${
                                                        price
                                                        ? `<span class="price fw-bolder text-info small fs-xl-6 fs-xxl-5 p-lg-0 p-xl-0">${price}€</span>`
                                                        : ''
                                                    }
                                                    ${
                                                        round
                                                        ? `<span class="nb fw-normal small">/${round} tours</span>`
                                                        : ''
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `);
                  },
                }
            }
        });
    });
}
